<template>
  <v-navigation-drawer
    right
    v-model="rightDrawerVal"
    :disable-resize-watcher="true"
    fixed
  >
    <v-list>
      <v-list-item class="my-2">
        <v-list-item-title class="title">Advanced Search</v-list-item-title>
      </v-list-item>
      <slot></slot>
      <v-layout class="pl-1 pt-3 ml-1" row>
        <v-btn
          elevation="4"
          class="purple mr-2"
          fab
          small
          dark
          @click="$emit('searchData')"
        >
          <v-icon dark>mdi-magnify</v-icon>
        </v-btn>
        <v-btn elevation="4" class="grey" fab small dark @click="$emit('cancelSearch')">
          <v-icon dark>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-layout>
    </v-list>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Props
interface Props {
  rightDrawer: boolean;
}

const props = defineProps<Props>();

// Emits
const emit = defineEmits<{
  "update:rightDrawer": [value: boolean];
  searchData: [];
  cancelSearch: [];
}>();

// Computed property for two-way binding
const rightDrawerVal = computed({
  get: () => props.rightDrawer,
  set: (value: boolean) => {
    emit("update:rightDrawer", value);
  },
});

// Local state
const right = true; // Not used in template, can be removed if not needed

// Lifecycle hooks if needed
// onMounted(() => {
//   // Mounted logic here
// });
</script>
